(() => {
  if (typeof window.customElements.get('band-upsells') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'band-upsells',
    class BandUpsells extends HTMLElement {
      constructor() {
        super();

        this.swiperContainer = this.querySelector('[data-band-upsells-swiper-container]');
        this.swiperScrollbar = this.querySelector('[data-band-upsells-swiper-scrollbar]');
        this.navNextButton = this.querySelector('[data-band-upsells-nav-next]');
        this.navPrevButton = this.querySelector('[data-band-upsells-nav-prev]');

        this.initBandUpsells();
      }

      initBandUpsells() {
        try {
          this.setupSwiper();
        } catch (error) {
          console.error('There was a problem with the BandUpsells component:', error);
        }
      }

      setupSwiper() {
        if (!this.swiperContainer) {
          return;
        }

        const bandUpsellsSwiper = new Swiper(this.swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          centeredSlides: true,
          loop: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          breakpoints: {
            750: {
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl: this.navNextButton,
            prevEl: this.navPrevButton,
          },
        });

        return bandUpsellsSwiper;
      }
    }
  );
})();
